import { useQuery } from '@tanstack/react-query'

import { env } from '@/config/env'
import { api, guard, unwrap } from '@/lib/api/client'

/**
 * Whether chat can actually run.
 *
 * The build-time flag only says whether this bundle ships the feature; the server decides
 * whether it has a model credential. Asking it means the empty state can say *why* chat is
 * unavailable instead of showing a composer that fails on the first message.
 */
export function useChatAvailability() {
  return useQuery({
    queryKey: ['chat', 'availability'],
    queryFn: () => guard(async () => unwrap(await api.GET('/api/chat/availability'))),
    enabled: env.chatEnabled,
    staleTime: 5 * 60_000,
    retry: false,
  })
}
